import PropTypes from 'prop-types';
import Modal from 'react-responsive-modal';
import AsyncImage from '../AsyncImage';
import { ReactComponent as ArrowLeft } from '../../assets/images/arrow-left.svg';

const ImageModal = ({ imageUrl, onClose, Btn, title, goTo, isMany, canClick }) => {
  const initStyles = {
    overlay: { backgroundColor: 'rgba(36, 39, 42, 0.3)' },
    modal: {
      padding: 0,
      minWidth: '98vw',
      maxWidth: '98vw',
      height: '96vh',
      borderRadius: '4px',
      boxShadow: '0 2px 8px 0 rgba(0, 0, 0, 0.08)',
      border: 'solid 1px #eaeeef',
      opacity: '1'
    }
  };

  return (
    <Modal
      open={!!imageUrl}
      onClose={onClose}
      center
      styles={initStyles}
      classNames={{
        overlay: 'modal-overflow-overLay',
        modal: 'custom-pdf-modal details',
        closeIcon: 'd-none',
        closeButton: 'd-none'
      }}
    >
      <div className="m-header">
        <h2>{title}</h2>
        <Btn />
      </div>
      <div className="modal-image-block">
        {isMany && (
          <button
            className={`move-btn ${canClick.prev && 'invisible'}`}
            type="button"
            onClick={() => goTo(-1)}
          >
            <ArrowLeft height={42} width={42} />
          </button>
        )}
        <AsyncImage url={imageUrl} />
        {isMany && (
          <button
            className={`move-btn ${canClick.next && 'invisible'}`}
            type="button"
            onClick={() => goTo(1)}
          >
            <ArrowLeft className="mirror-x" height={42} width={42} />
          </button>
        )}
      </div>
    </Modal>
  );
};

ImageModal.propTypes = {
  imageUrl: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
  Btn: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  goTo: PropTypes.func.isRequired,
  isMany: PropTypes.bool.isRequired,
  canClick: PropTypes.shape({
    next: PropTypes.bool,
    prev: PropTypes.bool
  }).isRequired
};

export default ImageModal;
